import React from 'react';
import ReactDOM from 'react-dom';
import CorePage from './CorePage';
import HmEventRegistry from './../../model/HmEventRegistry';
import browserStorageUtil from './../../util/BrowserStorageUtil';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
var toastStatus = {
  error: false,
  warn: false,
  info: false,
  success: false
}

var toastAutoCloseTime = 5000;

export default class ToastPage extends CorePage{
  constructor(props){
    super(props);
  }
  componentDidMount(){
      console.log("ToastPage componentDidMount")
  }

  showToast(toastdata){
    console.log("Toast Fired");
   
    var level = toastdata.level;

    if(level === "error"){
      this.error(toastdata);
    }else if(level === "warn"){
      this.warn(toastdata);
    }else if(level === "success"){
      this.success(toastdata);
    }else{
      this.info(toastdata);
    }

  }

  warn(toastdata){
    var me = this;

    toast.warn(<span>{ReactHtmlParser(me.rb(toastdata.msg))}</span>, {
      position: "top-center",
      autoClose: toastAutoCloseTime,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
      });

  }

  info(toastdata){
    var me = this;
   
    toast.info(<span>{ReactHtmlParser(me.rb(toastdata.msg))}</span>, {
      position: "top-center",
      autoClose: toastAutoCloseTime,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
      });
  }

  error(toastdata){
    var me = this;
   
    toast.error(<span>{ReactHtmlParser(me.rb(toastdata.msg))}</span>, {
      position: "top-center",
      autoClose: toastAutoCloseTime,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
      });
  }

  success(toastdata){
    var me = this;
   
    toast.success(<span>{ReactHtmlParser(me.rb(toastdata.msg))}</span>, {
      position: "top-center",
      autoClose: toastAutoCloseTime,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
      });
  }

  render() {
      return(
      <div>
    
    <ToastContainer/>
    {this.showToast(this.props.toastmsg)}
      </div>
      )
   }
}



HmEventRegistry.registerEvent("DESKTOP_EXP_TOAST",function(obj){
  //Disabled for co.za
  return;


  var level = (obj && obj.level) ? obj.level : "info";

    var toastTime = !isNaN(browserStorageUtil.getStoredItem("WARN_TOAST_TIME")) ? Number(browserStorageUtil.getStoredItem("WARN_TOAST_TIME")) : 0;
      //console.log("toastTime ", toastTime , " browserStorageUtil :", browserStorageUtil.getStoredItem("WARN_TOAST_TIME"))
    var intervalInSecs = window.toastTimer ? window.toastTimer : 900;
    console.log("intervalInSecs ",intervalInSecs)
    if(toastTime > 0){
      //Use interval check to display toast
      var currentTime = Math.round(new Date().getTime() / 1000);

      if((currentTime - toastTime) <= (intervalInSecs)){
        return;
      }else{
        browserStorageUtil.storeItem("WARN_TOAST_TIME", String(Math.round(new Date().getTime() / 1000)));
      }
    }else{
      browserStorageUtil.storeItem("WARN_TOAST_TIME", String(Math.round(new Date().getTime() / 1000)));
    }


  if(toastStatus && !toastStatus[level]){
    toastStatus[level] = true;
    ReactDOM.render(<ToastPage toastmsg={obj || {}}/>, document.getElementById('subroot'));	
  }

  setTimeout(() => {
    try{
        [level] = false;
    }catch(e){
      //console.log("failed to load "+toastStatus[level])
    }
  }, toastAutoCloseTime);

});


/*HmEventRegistry.registerEvent("SLOW_NET_1", function(){
  var toastData = {msg:"slow_net", level:"info"};

  ReactDOM.render(<ToastPage toastmsg={toastData}/>, document.getElementById('subroot')); 
});

HmEventRegistry.registerEvent("NO_NET_1", function(){
  var toastData = {msg:"no_net", level:"info"};

  ReactDOM.render(<ToastPage toastmsg={toastData}/>, document.getElementById('subroot')); 
});*/


// WEBPACK FOOTER //
// ./src/views/core/ToastPage.js